/** Typed application boundary for FIVB Rule 7.4 zone/order inputs. The legacy modules retain compatibility for the frozen oracle tests. */
import {resolve} from './phases.js';
import {zoneOf as legacyZoneOf,rotationWhere as legacyRotationWhere} from './rotation.js';
import {zoneAnchor as legacyZoneAnchor} from './court.js';
import type {Role,Rotation,Zone,FormationInput,Spot} from './types.js';
export type LineupRole=Exclude<Role,'L'>;
export interface FormationRequest extends Omit<FormationInput,'rotation'> {rotation:Rotation}
type LegacyFormation=ReturnType<typeof resolve>;
export interface Formation extends Omit<LegacyFormation,'spots'|'byZone'|'roster'|'passers'|'server'|'rotation'> {
 readonly spots:ReadonlyMap<Role,Readonly<Spot>>;
 readonly byZone:ReadonlyMap<Zone,Readonly<Spot>>;
 readonly roster:Omit<LegacyFormation['roster'],'slots'|'benched'> & {readonly slots:ReadonlyMap<Role,Zone>;readonly benched:Role|null};
 readonly passers:readonly Role[];readonly server:Role|null;readonly rotation:Rotation;
}
export const ROTATIONS:readonly Rotation[]=[1,2,3,4,5,6];
export const ROLES:readonly Role[]=['S','OH1','OH2','MB1','MB2','OPP','L'];
export function rotationFrom(value:number):Rotation {if(!ROTATIONS.includes(value as Rotation))throw new RangeError(`rotation must be 1–6: ${value}`);return value as Rotation;}
export function roleFrom(value:string):Role {if(!ROLES.includes(value as Role))throw new RangeError(`unknown role: ${value}`);return value as Role;}
export function resolveFormation(input:FormationRequest):Formation {
 // Only the finite supported 5–1 roster may cross this application boundary.
 const value=resolve(input);
 for(const [role,zone] of value.roster.slots){roleFrom(role);rotationFrom(zone);}
 return value as Formation;
}
export function zoneOf(role:LineupRole,rotation:Rotation):Zone{return legacyZoneOf(role,rotation) as Zone;}
export function rotationWhere(role:LineupRole,zone:Zone):Rotation{return legacyRotationWhere(role,zone) as Rotation;}
export function zoneAnchor(zone:Zone):Spot{return legacyZoneAnchor(zone);}
